let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3TRon")).then(() => parcelRequire('a7P6U'));